<template>
  <div class="survey-page">

    <app-loading
        v-if="loading"
    />

    <app-header
        :position="'fixed'"
        :top="'0px'"
        :background="'transparent'"
        @clickBack="ending.length > 0 ? $router.push('/video-editor') : $router.push('/add-ending')"
        @clickMenu="change_menu(context, true)"
    />

    <div class="survey-page__title">
      Закажите съёмку
    </div>

    <div class="survey-page__descr">
      Профессиональные операторы запечатлят ваше поздравление на видео в разрешении 4К.
    </div>


    <div class="survey-page__example-survey">
      <a href="https://www.instagram.com/52krd/" target="_blank">Смотреть примеры съёмок</a>
    </div>

    <div
        class="survey-page__element"
        @click="survey_select(context, {select: 'ground', status: true, overlay: true})"
    >
        <div class="survey-page__element-title">
          Съёмка с земли
        </div>
      <div class="survey-page__element-price">
          {{ surveyGround }} ₽
      </div>

      <div class="survey-page__element-svg-1">
        <svg width="86" height="100" viewBox="0 0 86 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M89.518 7.47168H53.6317C52.7455 7.47624 51.8969 7.82971 51.2695 8.45554C50.6421 9.08136 50.2865 9.92916 50.2798 10.8153V27.1517C50.2843 27.5869 50.3746 28.017 50.5456 28.4173C50.7165 28.8176 50.9648 29.1803 51.2762 29.4845C51.5876 29.7886 51.9559 30.0284 52.3601 30.19C52.7643 30.3516 53.1964 30.4318 53.6317 30.4261H89.518C89.9533 30.4318 90.3854 30.3516 90.7896 30.19C91.1938 30.0284 91.5621 29.7886 91.8735 29.4845C92.1849 29.1803 92.4332 28.8176 92.6042 28.4173C92.7751 28.017 92.8655 27.5869 92.8699 27.1517V10.8153C92.8632 9.92916 92.5076 9.08136 91.8802 8.45554C91.2528 7.82971 90.4042 7.47624 89.518 7.47168Z" fill="#FAFAFF"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M53.6317 7.47168H89.518C89.5202 7.47169 89.5224 7.4717 89.5247 7.47172H56.8657C55.9795 7.47628 55.1309 7.82975 54.5035 8.45558C53.8761 9.0814 53.5205 9.9292 53.5138 10.8153V27.1517C53.5183 27.587 53.6086 28.0171 53.7796 28.4174C53.9505 28.8177 54.1988 29.1803 54.5102 29.4845C54.8216 29.7887 55.1899 30.0284 55.5941 30.19C55.9706 30.3405 56.3712 30.4205 56.7761 30.4261H53.6317C53.1964 30.4318 52.7643 30.3516 52.3601 30.19C51.9559 30.0284 51.5876 29.7886 51.2762 29.4845C50.9648 29.1803 50.7165 28.8176 50.5456 28.4173C50.3746 28.017 50.2843 27.5869 50.2798 27.1517V10.8153C50.2865 9.92916 50.6421 9.08136 51.2695 8.45554C51.8969 7.82971 52.7455 7.47624 53.6317 7.47168ZM89.5212 30.4262C89.548 30.4265 89.5748 30.4265 89.6015 30.4262H89.5212Z" fill="#DFF5FE"/>
          <path d="M124.434 40.9092H18.716C17.4097 40.9113 16.1166 41.171 14.9108 41.6734C13.7049 42.1758 12.6099 42.9111 11.6885 43.8371C10.7671 44.7631 10.0374 45.8618 9.54102 47.0701C9.04466 48.2785 8.79143 49.5728 8.79583 50.8791V116.108C8.79143 117.415 9.04458 118.71 9.54081 119.919C10.037 121.128 10.7666 122.228 11.6879 123.154C12.6091 124.081 13.704 124.818 14.9099 125.321C16.1158 125.825 17.4092 126.086 18.716 126.089H124.434C125.74 126.086 127.034 125.825 128.24 125.321C129.446 124.818 130.541 124.081 131.462 123.154C132.383 122.228 133.113 121.128 133.609 119.919C134.105 118.71 134.358 117.415 134.354 116.108V50.8791C134.358 49.5728 134.105 48.2785 133.609 47.0701C133.112 45.8618 132.382 44.7631 131.461 43.8371C130.54 42.9111 129.445 42.1758 128.239 41.6734C127.033 41.171 125.74 40.9113 124.434 40.9092Z" fill="#B0A3FF"/>
          <path d="M57.5032 16.3732C57.5032 15.4422 58.2579 14.6875 59.1889 14.6875H83.9602C84.8912 14.6875 85.6459 15.4422 85.6459 16.3732V21.5945C85.6459 22.5255 84.8912 23.2802 83.9602 23.2802H59.1889C58.2579 23.2802 57.5032 22.5255 57.5032 21.5945V16.3732Z" fill="#90D2FC"/>
          <path d="M41.1643 40.9091V40.9229H25.3811V40.9091V36.0003C25.3811 34.1383 26.8905 32.6289 28.7525 32.6289H37.793C39.6549 32.6289 41.1643 34.1383 41.1643 36.0003V40.9091Z" fill="#CCD3DF"/>
          <path d="M71.5739 54.8643C77.2957 54.8645 82.8888 56.5615 87.6461 59.7405C92.4034 62.9196 96.1111 67.4379 98.3005 72.7242C100.49 78.0105 101.062 83.8273 99.9459 89.439C98.8294 95.0507 96.0739 100.205 92.0278 104.251C87.9818 108.297 82.8269 111.052 77.2151 112.168C71.6033 113.284 65.7865 112.71 60.5004 110.521C55.2144 108.331 50.6964 104.623 47.5178 99.865C44.3392 95.1074 42.6428 89.5141 42.6431 83.7924C42.6436 76.1198 45.6919 68.7617 51.1175 63.3367C56.543 57.9117 63.9014 54.864 71.5739 54.8643Z" fill="#7D6EDC"/>
          <path d="M22.6073 57.6313C22.6073 54.8384 24.8714 52.5742 27.6644 52.5742H36.7849C39.5779 52.5742 41.842 54.8384 41.842 57.6313V57.7498C41.842 60.5428 39.5779 62.8069 36.7849 62.8069H27.6644C24.8714 62.8069 22.6073 60.5428 22.6073 57.7498V57.6313Z" fill="#EDF4FF"/>
          <path d="M71.5752 65.1768C75.2573 65.177 78.8565 66.2691 81.9178 68.315C84.9792 70.3608 87.3651 73.2685 88.7739 76.6704C90.1827 80.0722 90.5511 83.8154 89.8325 87.4266C89.1139 91.0379 87.3406 94.3549 84.7368 96.9583C82.133 99.5617 78.8157 101.334 75.2044 102.053C71.5931 102.771 67.85 102.402 64.4483 100.992C61.0467 99.583 58.1394 97.1967 56.094 94.135C54.0486 91.0734 52.957 87.474 52.9573 83.792C52.9573 81.3472 53.4389 78.9263 54.3746 76.6677C55.3103 74.409 56.6817 72.3567 58.4106 70.6281C60.1395 68.8995 62.1919 67.5284 64.4507 66.593C66.7095 65.6577 69.1304 65.1764 71.5752 65.1768Z" fill="#90D2FC"/>
          <path d="M17.0926 116.108V50.8791C17.0882 49.5728 17.3414 48.2785 17.8378 47.0701C18.3342 45.8618 19.0639 44.7631 19.9853 43.8371C20.9067 42.9111 22.0017 42.1758 23.2075 41.6734C24.4134 41.171 25.7065 40.9113 27.0128 40.9092H18.716C17.4097 40.9113 16.1166 41.171 14.9108 41.6734C13.7049 42.1758 12.6099 42.9111 11.6885 43.8371C10.7671 44.7631 10.0374 45.8618 9.54102 47.0701C9.04466 48.2785 8.79143 49.5728 8.79583 50.8791V116.108C8.79143 117.415 9.04458 118.71 9.54081 119.919C10.037 121.128 10.7666 122.228 11.6879 123.154C12.6091 124.081 13.704 124.818 14.9099 125.321C16.1158 125.825 17.4092 126.086 18.716 126.089H27.0128C25.706 126.086 24.4126 125.825 23.2067 125.321C22.0008 124.818 20.9059 124.081 19.9847 123.154C19.0634 122.228 18.3338 121.128 17.8376 119.919C17.3414 118.71 17.0882 117.415 17.0926 116.108Z" fill="#A193FF"/>
          <path d="M61.2536 83.792C61.2544 79.5759 62.6863 75.4849 65.3149 72.1886C67.9434 68.8922 71.613 66.5857 75.7231 65.6464C72.9959 65.0219 70.1629 65.0202 67.4349 65.6414C64.7068 66.2626 62.1539 67.4907 59.9659 69.2343C57.7778 70.978 56.0109 73.1925 54.7965 75.713C53.5822 78.2336 52.9515 80.9955 52.9515 83.7934C52.9515 86.5912 53.5822 89.3531 54.7965 91.8737C56.0109 94.3942 57.7778 96.6087 59.9659 98.3524C62.1539 100.096 64.7068 101.324 67.4349 101.945C70.1629 102.566 72.9959 102.565 75.7231 101.94C71.6129 101 67.9433 98.6932 65.3148 95.3964C62.6863 92.0996 61.2545 88.0084 61.2536 83.792Z" fill="#63C2FF"/>
          <path d="M61.9421 30.3994H80.4848V42.1993C80.4848 44.9922 78.2207 47.2564 75.4277 47.2564H66.9992C64.2063 47.2564 61.9421 44.9922 61.9421 42.1993V30.3994Z" fill="#B0BCCA"/>
        </svg>
      </div>
    </div>

    <div
        class="survey-page__element survey-page__element_color-2"
        @click="survey_select(context, {select: 'air', status: true, overlay: true})"
    >
      <div class="survey-page__element-title">
        Съёмка с воздуха
      </div>
      <div class="survey-page__element-price">
        {{ surveyAerial }} ₽
      </div>

      <div class="survey-page__element-svg-1">
        <svg width="83" height="100" viewBox="0 0 83 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M40.8198 35.9604H50.8317C54.5717 29.0991 60.9634 23.8967 68.6349 21.7341C67.0915 17.9868 63.406 15.3489 59.1033 15.3489C58.0277 15.3489 56.9915 15.5146 56.0177 15.8195C56.0229 15.663 56.0297 15.5067 56.0297 15.3489C56.0297 7.69516 49.8233 1.48926 42.169 1.48926C35.5677 1.48926 30.049 6.1039 28.6533 12.2823C27.8242 12.0059 26.9395 11.8547 26.018 11.8547C23.1826 11.8547 20.6795 13.2742 19.1785 15.441C18.341 15.2251 17.4616 15.1081 16.5563 15.1081C10.7985 15.1081 6.13098 19.7759 6.13098 25.534C6.13098 31.291 10.7988 35.9598 16.5563 35.9598H33.2245" fill="#9FDEF7"/>
          <path d="M97.7618 29.6494C92.4049 23.9195 84.7786 20.3379 76.3162 20.3379C62.3382 20.3379 50.6504 30.1118 47.694 43.1965C45.9394 42.6113 44.0652 42.2894 42.1146 42.2894C36.109 42.2894 30.8094 45.2965 27.6308 49.885C25.8566 49.4267 23.996 49.1805 22.0782 49.1805C9.88463 49.1805 0 59.0651 0 71.2586C0 83.4516 9.88463 93.3376 22.0782 93.3376H46.421C46.4723 85.8327 52.5685 79.7653 60.0843 79.7653C61.5096 79.7653 62.8839 79.9838 64.1758 80.3887C64.1698 80.1819 64.1603 79.9747 64.1603 79.7653C64.1603 69.614 72.3893 61.3847 82.5404 61.3847C91.2931 61.3847 98.6126 67.5056 100.464 75.6984C101.562 75.3318 102.735 75.1305 103.957 75.1305C107.717 75.1305 111.036 77.0133 113.027 79.8873C114.138 79.5999 115.302 79.4455 116.503 79.4455C121.536 79.4455 125.94 82.1357 128.358 86.1552C131.864 82.2836 134 77.1484 134 71.5146C134 59.4608 124.229 49.6913 112.176 49.6913C109.901 49.6913 107.706 50.0402 105.643 50.6867C105.654 50.3561 105.668 50.0248 105.668 49.6913C105.668 44.7626 104.454 40.1179 102.307 36.0392" fill="#BEEAFC"/>
          <path d="M23.4087 49.2208C22.9685 49.1941 22.5252 49.1797 22.0782 49.1797C9.88463 49.1794 0 59.0643 0 71.2578C0 83.4508 9.88463 93.3368 22.0782 93.3368H46.421C46.4369 90.9818 47.0491 88.7687 48.1127 86.8401C36.0765 77.5771 27.2086 64.4045 23.4087 49.2208Z" fill="#AEE4FF"/>
          <path d="M21.36 32.5465C21.36 25.3853 22.4614 18.4822 24.5004 11.9941C22.3014 12.4001 20.4055 13.671 19.1789 15.4413C18.3414 15.2253 17.462 15.1083 16.5567 15.1083C10.7989 15.1083 6.13135 19.7761 6.13135 25.5342C6.13135 31.2913 10.7991 35.9601 16.5567 35.9601H21.4451C21.3896 34.8289 21.36 33.6912 21.36 32.5465Z" fill="#92DBF1"/>
          <path d="M116.504 78.8615C115.303 78.8615 114.137 79.0154 113.027 79.3033C111.037 76.4291 107.717 74.5466 103.957 74.5466C102.735 74.5466 101.562 74.7478 100.464 75.1145C98.6126 66.9214 91.2934 60.8008 82.5407 60.8008C72.3896 60.8008 64.1606 69.03 64.1606 79.1814C64.1606 79.3907 64.1698 79.598 64.1761 79.8048C62.8842 79.3999 61.5099 79.1814 60.0846 79.1814C52.5379 79.1814 46.4197 85.2985 46.4197 92.8473C46.4197 100.394 52.5382 106.512 60.0846 106.512H100.999H108.592H116.504C124.14 106.512 130.33 100.322 130.33 92.6866C130.329 85.051 124.139 78.8615 116.504 78.8615Z" fill="#E4F2F9"/>
          <path d="M74.6576 75.3371C74.6576 70.4045 75.7045 65.7169 77.5849 61.4814C69.8419 63.6451 64.16 70.7471 64.16 79.1808C64.16 79.3901 64.1692 79.5974 64.1754 79.8042C62.8836 79.3993 61.5093 79.1808 60.084 79.1808C52.5373 79.1808 46.4191 85.2979 46.4191 92.8467C46.4191 100.393 52.5376 106.511 60.084 106.511H94.8082C82.9285 101.158 74.6576 89.2135 74.6576 75.3371Z" fill="#D7EDF9"/>
        </svg>
      </div>
    </div>

    <div
        class="survey-page__element survey-page__element_color-4"
        @click="survey_select(context, {select: 'ground-air', status: true, overlay: true})"
    >
      <div class="survey-page__element-title">
        Съёмка с земли и с воздуха
      </div>
      <div class="survey-page__element-price">
        {{ surveyGroundAerial }} ₽
      </div>

      <div class="survey-page__element-svg-1">
        <svg width="83" height="100" viewBox="0 0 83 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M40.8198 35.9604H50.8317C54.5717 29.0991 60.9634 23.8967 68.6349 21.7341C67.0915 17.9868 63.406 15.3489 59.1033 15.3489C58.0277 15.3489 56.9915 15.5146 56.0177 15.8195C56.0229 15.663 56.0297 15.5067 56.0297 15.3489C56.0297 7.69516 49.8233 1.48926 42.169 1.48926C35.5677 1.48926 30.049 6.1039 28.6533 12.2823C27.8242 12.0059 26.9395 11.8547 26.018 11.8547C23.1826 11.8547 20.6795 13.2742 19.1785 15.441C18.341 15.2251 17.4616 15.1081 16.5563 15.1081C10.7985 15.1081 6.13098 19.7759 6.13098 25.534C6.13098 31.291 10.7988 35.9598 16.5563 35.9598H33.2245" fill="#9FDEF7"/>
          <path d="M97.7618 29.6494C92.4049 23.9195 84.7786 20.3379 76.3162 20.3379C62.3382 20.3379 50.6504 30.1118 47.694 43.1965C45.9394 42.6113 44.0652 42.2894 42.1146 42.2894C36.109 42.2894 30.8094 45.2965 27.6308 49.885C25.8566 49.4267 23.996 49.1805 22.0782 49.1805C9.88463 49.1805 0 59.0651 0 71.2586C0 83.4516 9.88463 93.3376 22.0782 93.3376H46.421C46.4723 85.8327 52.5685 79.7653 60.0843 79.7653C61.5096 79.7653 62.8839 79.9838 64.1758 80.3887C64.1698 80.1819 64.1603 79.9747 64.1603 79.7653C64.1603 69.614 72.3893 61.3847 82.5404 61.3847C91.2931 61.3847 98.6126 67.5056 100.464 75.6984C101.562 75.3318 102.735 75.1305 103.957 75.1305C107.717 75.1305 111.036 77.0133 113.027 79.8873C114.138 79.5999 115.302 79.4455 116.503 79.4455C121.536 79.4455 125.94 82.1357 128.358 86.1552C131.864 82.2836 134 77.1484 134 71.5146C134 59.4608 124.229 49.6913 112.176 49.6913C109.901 49.6913 107.706 50.0402 105.643 50.6867C105.654 50.3561 105.668 50.0248 105.668 49.6913C105.668 44.7626 104.454 40.1179 102.307 36.0392" fill="#BEEAFC"/>
          <path d="M23.4087 49.2208C22.9685 49.1941 22.5252 49.1797 22.0782 49.1797C9.88463 49.1794 0 59.0643 0 71.2578C0 83.4508 9.88463 93.3368 22.0782 93.3368H46.421C46.4369 90.9818 47.0491 88.7687 48.1127 86.8401C36.0765 77.5771 27.2086 64.4045 23.4087 49.2208Z" fill="#AEE4FF"/>
          <path d="M21.36 32.5465C21.36 25.3853 22.4614 18.4822 24.5004 11.9941C22.3014 12.4001 20.4055 13.671 19.1789 15.4413C18.3414 15.2253 17.462 15.1083 16.5567 15.1083C10.7989 15.1083 6.13135 19.7761 6.13135 25.5342C6.13135 31.2913 10.7991 35.9601 16.5567 35.9601H21.4451C21.3896 34.8289 21.36 33.6912 21.36 32.5465Z" fill="#92DBF1"/>
          <path d="M116.504 78.8615C115.303 78.8615 114.137 79.0154 113.027 79.3033C111.037 76.4291 107.717 74.5466 103.957 74.5466C102.735 74.5466 101.562 74.7478 100.464 75.1145C98.6126 66.9214 91.2934 60.8008 82.5407 60.8008C72.3896 60.8008 64.1606 69.03 64.1606 79.1814C64.1606 79.3907 64.1698 79.598 64.1761 79.8048C62.8842 79.3999 61.5099 79.1814 60.0846 79.1814C52.5379 79.1814 46.4197 85.2985 46.4197 92.8473C46.4197 100.394 52.5382 106.512 60.0846 106.512H100.999H108.592H116.504C124.14 106.512 130.33 100.322 130.33 92.6866C130.329 85.051 124.139 78.8615 116.504 78.8615Z" fill="#E4F2F9"/>
          <path d="M74.6576 75.3371C74.6576 70.4045 75.7045 65.7169 77.5849 61.4814C69.8419 63.6451 64.16 70.7471 64.16 79.1808C64.16 79.3901 64.1692 79.5974 64.1754 79.8042C62.8836 79.3993 61.5093 79.1808 60.084 79.1808C52.5373 79.1808 46.4191 85.2979 46.4191 92.8467C46.4191 100.393 52.5376 106.511 60.084 106.511H94.8082C82.9285 101.158 74.6576 89.2135 74.6576 75.3371Z" fill="#D7EDF9"/>
        </svg>
      </div>

      <div class="survey-page__element-svg-4">
        <svg width="127" height="100" viewBox="0 0 127 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.4">
            <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="127" height="100">
              <rect width="127" height="100" rx="12" transform="matrix(-1 0 0 1 127 0)" fill="url(#paint0_linear)"/>
            </mask>
            <g mask="url(#mask0)">
              <path d="M-3.51755 7.47168H32.3688C33.2549 7.47624 34.1036 7.82971 34.731 8.45554C35.3584 9.08136 35.714 9.92916 35.7207 10.8153V27.1517C35.7162 27.5869 35.6259 28.017 35.4549 28.4173C35.2839 28.8176 35.0356 29.1803 34.7243 29.4845C34.4129 29.7886 34.0446 30.0284 33.6404 30.19C33.2362 30.3516 32.8041 30.4318 32.3688 30.4261H-3.51755C-3.95281 30.4318 -4.38492 30.3516 -4.78911 30.19C-5.19331 30.0284 -5.56164 29.7886 -5.87302 29.4845C-6.18439 29.1803 -6.43268 28.8176 -6.60367 28.4173C-6.77465 28.017 -6.86497 27.5869 -6.86945 27.1517V10.8153C-6.8627 9.92916 -6.50712 9.08136 -5.87974 8.45554C-5.25236 7.82971 -4.40369 7.47624 -3.51755 7.47168Z" fill="#FAFAFF"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3688 7.47168H-3.51755C-3.51976 7.47169 -3.52196 7.4717 -3.52417 7.47172H29.1348C30.0209 7.47628 30.8696 7.82975 31.497 8.45558C32.1244 9.0814 32.48 9.9292 32.4867 10.8153V27.1517C32.4822 27.587 32.3919 28.0171 32.2209 28.4174C32.0499 28.8177 31.8016 29.1803 31.4903 29.4845C31.1789 29.7887 30.8106 30.0284 30.4064 30.19C30.0299 30.3405 29.6293 30.4205 29.2244 30.4261H32.3688C32.8041 30.4318 33.2362 30.3516 33.6404 30.19C34.0446 30.0284 34.4129 29.7886 34.7243 29.4845C35.0356 29.1803 35.2839 28.8176 35.4549 28.4173C35.6259 28.017 35.7162 27.5869 35.7207 27.1517V10.8153C35.714 9.92916 35.3584 9.08136 34.731 8.45554C34.1036 7.82971 33.2549 7.47624 32.3688 7.47168ZM-3.52073 30.4262C-3.5475 30.4265 -3.57427 30.4265 -3.60102 30.4262H-3.52073Z" fill="#DFF5FE"/>
              <path d="M-38.4337 40.9092H67.2839C68.5902 40.9113 69.8833 41.171 71.0891 41.6734C72.295 42.1758 73.3899 42.9111 74.3113 43.8371C75.2327 44.7631 75.9625 45.8618 76.4589 47.0701C76.9552 48.2785 77.2084 49.5728 77.204 50.8791V116.108C77.2084 117.415 76.9553 118.71 76.4591 119.919C75.9628 121.128 75.2333 122.228 74.312 123.154C73.3907 124.081 72.2959 124.818 71.09 125.321C69.884 125.825 68.5907 126.086 67.2839 126.089H-38.4337C-39.7406 126.086 -41.0339 125.825 -42.2398 125.321C-43.4458 124.818 -44.5406 124.081 -45.4619 123.154C-46.3831 122.228 -47.1127 121.128 -47.609 119.919C-48.1052 118.71 -48.3583 117.415 -48.3539 116.108V50.8791C-48.3583 49.5728 -48.1051 48.2785 -47.6087 47.0701C-47.1124 45.8618 -46.3826 44.7631 -45.4612 43.8371C-44.5398 42.9111 -43.4449 42.1758 -42.239 41.6734C-41.0332 41.171 -39.7401 40.9113 -38.4337 40.9092Z" fill="#B0A3FF"/>
              <path d="M28.4971 16.3732C28.4971 15.4422 27.7424 14.6875 26.8114 14.6875H2.04007C1.10909 14.6875 0.35438 15.4422 0.35438 16.3732V21.5945C0.35438 22.5255 1.10909 23.2802 2.04007 23.2802H26.8114C27.7424 23.2802 28.4971 22.5255 28.4971 21.5945V16.3732Z" fill="#90D2FC"/>
              <path d="M44.8359 40.9091V40.9229H60.6191V40.9091V36.0003C60.6191 34.1383 59.1097 32.6289 57.2477 32.6289H48.2073C46.3453 32.6289 44.8359 34.1383 44.8359 36.0003V40.9091Z" fill="#CCD3DF"/>
              <path d="M14.4265 54.8643C8.70482 54.8645 3.11168 56.5615 -1.6456 59.7405C-6.40288 62.9196 -10.1106 67.4379 -12.3 72.7242C-14.4893 78.0105 -15.062 83.8273 -13.9454 89.439C-12.8289 95.0507 -10.0734 100.205 -6.02735 104.251C-1.98129 108.297 3.17358 111.052 8.78541 112.168C14.3972 113.284 20.214 112.71 25.5 110.521C30.7861 108.331 35.3041 104.623 38.4827 99.865C41.6613 95.1074 43.3577 89.5141 43.3574 83.7924C43.3569 76.1198 40.3086 68.7617 34.883 63.3367C29.4575 57.9117 22.0991 54.864 14.4265 54.8643Z" fill="#7D6EDC"/>
              <path d="M63.3926 57.6313C63.3926 54.8384 61.1284 52.5742 58.3355 52.5742H49.215C46.422 52.5742 44.1579 54.8384 44.1579 57.6313V57.7498C44.1579 60.5428 46.422 62.8069 49.215 62.8069H58.3355C61.1284 62.8069 63.3926 60.5428 63.3926 57.7498V57.6313Z" fill="#EDF4FF"/>
              <path d="M14.425 65.1768C10.743 65.177 7.14374 66.2691 4.08241 68.315C1.02108 70.3608 -1.36484 73.2685 -2.77363 76.6704C-4.18243 80.0722 -4.55082 83.8154 -3.83223 87.4266C-3.11363 91.0379 -1.34033 94.3549 1.26344 96.9583C3.86721 99.5617 7.18451 101.334 10.7958 102.053C14.4071 102.771 18.1503 102.402 21.5519 100.992C24.9535 99.583 27.8609 97.1967 29.9063 94.135C31.9517 91.0734 33.0432 87.474 33.043 83.792C33.0429 81.3472 32.5613 78.9263 31.6256 76.6677C30.6899 74.409 29.3185 72.3567 27.5896 70.6281C25.8608 68.8995 23.8083 67.5284 21.5495 66.593C19.2907 65.6577 16.8698 65.1764 14.425 65.1768Z" fill="#90D2FC"/>
              <path d="M68.9073 116.108V50.8791C68.9117 49.5728 68.6584 48.2785 68.1621 47.0701C67.6657 45.8618 66.9359 44.7631 66.0145 43.8371C65.0932 42.9111 63.9982 42.1758 62.7923 41.6734C61.5865 41.171 60.2934 40.9113 58.9871 40.9092H67.2839C68.5902 40.9113 69.8833 41.171 71.0891 41.6734C72.295 42.1758 73.3899 42.9111 74.3113 43.8371C75.2327 44.7631 75.9625 45.8618 76.4589 47.0701C76.9552 48.2785 77.2084 49.5728 77.204 50.8791V116.108C77.2084 117.415 76.9553 118.71 76.4591 119.919C75.9628 121.128 75.2333 122.228 74.312 123.154C73.3907 124.081 72.2959 124.818 71.09 125.321C69.884 125.825 68.5907 126.086 67.2839 126.089H58.9871C60.2939 126.086 61.5873 125.825 62.7932 125.321C63.9991 124.818 65.094 124.081 66.0152 123.154C66.9365 122.228 67.6661 121.128 68.1623 119.919C68.6585 118.71 68.9117 117.415 68.9073 116.108Z" fill="#A193FF"/>
              <path d="M24.7468 83.792C24.7459 79.5759 23.3141 75.4849 20.6855 72.1886C18.0569 68.8922 14.3873 66.5857 10.2772 65.6464C13.0045 65.0219 15.8375 65.0202 18.5655 65.6414C21.2935 66.2626 23.8465 67.4907 26.0345 69.2343C28.2226 70.978 29.9894 73.1925 31.2038 75.713C32.4182 78.2336 33.0488 80.9955 33.0488 83.7934C33.0488 86.5912 32.4182 89.3531 31.2038 91.8737C29.9894 94.3942 28.2226 96.6087 26.0345 98.3524C23.8465 100.096 21.2935 101.324 18.5655 101.945C15.8375 102.566 13.0045 102.565 10.2772 101.94C14.3875 101 18.0571 98.6932 20.6856 95.3964C23.3141 92.0996 24.7459 88.0084 24.7468 83.792Z" fill="#63C2FF"/>
              <path d="M24.0586 30.3994H5.51594V42.1993C5.51594 44.9922 7.78008 47.2564 10.573 47.2564H19.0015C21.7945 47.2564 24.0586 44.9922 24.0586 42.1993V30.3994Z" fill="#B0BCCA"/>
            </g>
          </g>
          <defs>
            <linearGradient id="paint0_linear" x1="127" y1="3.75157e-06" x2="-4.34757" y2="6.67615" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FFA6B2"/>
              <stop offset="0.260417" stop-color="#FF8799"/>
              <stop offset="0.510417" stop-color="#FF768A"/>
              <stop offset="0.78125" stop-color="#FF647C"/>
              <stop offset="1" stop-color="#FF4764"/>
            </linearGradient>
          </defs>
        </svg>

      </div>
    </div>

    <div
        class="survey-page__element survey-page__element_color-3"
        @click="survey_no_shooting(context)"
    >
      <div class="survey-page__element-title">
        Без съёмки
      </div>
      <div class="survey-page__element-price">
        0 ₽
      </div>

      <div class="survey-page__element-svg-1" style="opacity: .5">
        <svg width="87" height="96" viewBox="0 0 87 96" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M22.9351 7.8237L15.8231 14.9357L23.6463 22.7589L15.8232 30.582L22.9352 37.694L30.7583 29.871L38.5815 37.6941L45.6935 30.5821L37.8703 22.7589L45.6937 14.9356L38.5817 7.82361L30.7583 15.6469L22.9351 7.8237Z" fill="white"/>
          <path opacity="0.7" fill-rule="evenodd" clip-rule="evenodd" d="M58.976 43.0347L48.0351 53.9757L60.0699 66.0105L48.0348 78.0456L58.9758 88.9865L71.0108 76.9514L83.046 88.9867L93.987 78.0457L81.9517 66.0105L93.9867 53.9755L83.0458 43.0346L71.0108 55.0696L58.976 43.0347Z" fill="white"/>
          <path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M8.64691 54.5289L4.52939 58.6464L9.05855 63.1756L4.52917 67.7049L8.64669 71.8225L13.1761 67.2931L17.7055 71.8225L21.823 67.7049L17.2936 63.1756L21.8228 58.6464L17.7052 54.5289L13.1761 59.058L8.64691 54.5289Z" fill="white"/>
        </svg>
      </div>
    </div>


    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >
      <app-overlay
          v-if="overlay"
      />
    </transition>


    <transition
        name="fade-menu"
        appear
        mode="out-in"
    >
      <app-menu
          v-if="menu"
          idLogoMenu="header-component__menu"
          @clickLink="change_menu(context, false)"
          @clickOutside="change_menu(context, false)"
      />
    </transition >

    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >

      <app-alert
          v-if="alert.status"
          :secondButtonText="'Ок'"
          :is_slot="true"
          @clickCancelPopup="() => {
            alert.status = false
            overlay = false
          }"
          @clickDeletePopup="survey_click_alert_ok(context)"
      >
        <template
            v-slot:header
        >
          <div class="survey-page-alert-slot" v-if="select === 'ground' || select === 'ground-air'">
            Заказ съемки с земли возможен минимум за 3 дня до шоу. <br><br>
            Наши операторы самостоятельно свяжутся с вами в случае заказа.<br><br>
            Готовый ролик мы отдаем в течение 2 недель после показа шоу.
            Если до вашего показа менее 3 дней, выбирайте только съемку с воздуха.
          </div>
          <div class="survey-page-alert-slot" v-if="select === 'air'">
            Готовый ролик мы отдаем в течение 2 недель после показа шоу.
          </div>
        </template>
      </app-alert>

    </transition>

    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >

      <app-error
          v-if="error.status"
          :buttonText="error.button"
          :text="error.text"
          @clickGrowButtonPopup="() => {
              error.status = false
              overlay = false
              loading = false
              $router.push(error.push)
            }"
      />

    </transition>

  </div>
</template>

<script>

const AppLoading = () => import('@/components/loading.vue')
const AppHeader = () => import('@/components/header.vue')
const AppOverlay = () => import('@/components/overlay.vue')
const AppMenu = () => import('@/components/menu.vue')
const AppAlert = () => import('@/components/popups/popup.vue')
const AppError = () => import('@/components/popups/error')

import building_videos from "@/views/survey/modules/building_videos";
import validate_videos from "@/views/survey/modules/validate_videos";
import change_menu from "@/views/theme/modules/change_menu";
import survey_select from "@/views/survey/modules/survey_select";
import survey_no_shooting from "@/views/survey/modules/survey_no_shooting";
import survey_click_alert_ok from "@/views/survey/modules/survey_click_alert_ok";

export default {
  async mounted() {
    await this.building_videos(this)
    await this.validate_videos(this)
  },
  data() {
    return {
      context: this,
      menu: false,
      videos: [],
      overlay: false,
      select: false,
      loading: true,
      alert: {
        status: false,
        textButton: 'Продолжить'
      },
      error: {
        status: false,
        text: '',
        button: '',
        push: ''
      }
    }
  },
  components: {
    AppHeader,
    AppOverlay,
    AppMenu,
    AppAlert,
    AppLoading,
    AppError
  },
  methods: {
    building_videos,
    validate_videos,
    change_menu,
    survey_select,
    survey_no_shooting,
    survey_click_alert_ok
  },
  computed: {
    surveyGround() {
      return this.$store.getters['settings/priceSurveyGround']
    },
    surveyAerial() {
      return this.$store.getters['settings/priceSurveyAerial']
    },
    surveyGroundAerial() {
      return this.$store.getters['settings/priceSurveyGroundAerial']
    },
    ending() {
      return this.$store.getters['ending_video/ending']
    },
    entry() {
      return this.$store.getters['entry_video/entry']
    },
    main() {
      return this.$store.getters['main_videos/main']
    }
  }
}
</script>

<style lang="less">

  .survey-page {
    background-color: #2F1F4C;
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    min-height: 700px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0px 16px;
  }

  @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

  .survey-page__title {
    font-size: 28px;
    line-height: 20px;
    font-family: 'Montserrat-Bold';
    color: #FFFFFF;
    margin-top: 48px;
    margin-bottom: 29px;
  }

  @import '~/assets/fonts/roboto/Roboto-Light.less';

  .survey-page__descr {
    font-size: 15px;
    color: #FFFFFF;
    font-family: 'Roboto-Light';
    max-width: 343px;
    text-align: center;
  }

  @import '~/assets/fonts/roboto/Roboto-Regular.less';

  .survey-page__example-survey {
    font-family: 'Roboto-Regular';
    font-size: 15px;
    color: #70C5FA;
    border-bottom: 1px dashed #70C5FA;
    cursor: pointer;
    margin-top: 12px;
    margin-bottom: 40px;
  }

  .survey-page__example-survey a {
    text-decoration: none;
    color: #70C5FA;
  }

  .survey-page__element {
    width: 100%;
    height: 100px;
    display: flex;
    cursor: pointer;
    flex-direction: column;
    max-width: 343px;
    min-height: 100px;
    border-radius: 12px;
    padding: 17px 28px;
    color: #FFFFFF;
    position: relative;
    background: linear-gradient(267.71deg, #FFA6B2 0%, #FF8799 25.96%, #FF768A 50.89%, #FF647C 77.89%, #FF4764 99.7%);
    font-family: 'Montserrat-Bold';
    overflow: hidden;
  }

  .survey-page__element_color-2 {
    background: linear-gradient(267.71deg, #86DBFF 0%, #84BCFF 25.96%, #77BEFF 50.89%, #51ABFF 77.89%, #299BEE 99.7%);
    margin-top: 16px;
  }

  .survey-page__element_color-4 {
    background: linear-gradient(267.71deg, #69D2FF 0%, #84BCFF 25.96%, #43CD82 55.69%, #42C82C 81.9%, #3BC026 99.7%);
    margin-top: 16px;
  }

  .survey-page__element_color-3 {
    background: #7C7992;
    margin-top: 16px;
  }

  .survey-page__element-title {
    font-size: 19px;
    z-index: 5;
  }

  .survey-page__element-price {
    font-size: 26px;
    margin-top: 13px;
    text-transform: uppercase;
    z-index: 5;
  }

  .survey-page__element-svg-1 {
    display: flex;
    position: absolute;
    right: 0px;
    top: 0px;
  }

  .survey-page__element-svg-4 {
    display: flex;
    position: absolute;
    left: 0px;
    top: 0px;
  }

  @import '~/assets/fonts/roboto/Roboto-Medium.less';

  .survey-page-alert-slot {
    text-align: center;
    font-size: 15px;
    color: #31283D;
    font-family: 'Roboto-Medium';
  }

</style>